import type { XMarkdownProps } from '@ant-design/x-markdown'

type MarkedConfig = NonNullable<XMarkdownProps['config']>

const TITLES: Record<string, string> = {
  note: 'Note',
  tip: 'Tip',
  important: 'Important',
  warning: 'Warning',
  caution: 'Caution'
}

const DETECT = /^\s*\[!(note|tip|important|warning|caution)\]/i
const STRIP = /\[!(?:note|tip|important|warning|caution)\]\s*/i

export const markedAlert: MarkedConfig = {
  renderer: {
    blockquote(token) {
      const match = token.text.match(DETECT)
      if (!match) return false
      const type = match[1].toLowerCase()
      const body = this.parser.parse(token.tokens).replace(STRIP, '')

      return `<div class="skx-md-alert skx-md-alert-${type}"><p class="skx-md-alert-title">${TITLES[type]}</p>${body}</div>`
    }
  }
}
